import {KML} from "ol/format";
import {Feature} from "ol";
import JSZip from "jszip";
import {ReadOptions} from "ol/format/Feature";
import {AsyncFeatureFormat} from "./AsyncFeatureFormat";
import {Geometry} from "ol/geom";

function fixKMZHrefs(content: string, zip: JSZip): Promise<XMLDocument> {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "application/xml") as XMLDocument;

    const promises = [];

    doc.querySelectorAll('href').forEach(href => {
        // we need to check every href in the document to see if it points to files within the zip
        // and rewrite the relative (to the root of the zip file) URLs into blob URLs
        const content = href.textContent;
        const maybeFile = zip.file(content);
        const HTTP = 'http://';

        if (maybeFile) { // the href points to a file within the document...
            const p = maybeFile.async('blob').then(blob => {
                href.textContent = URL.createObjectURL(blob);
            }).catch(e => {
                console.warn('Trouble reading and convert blob', e);
            });

            promises.push(p);
        } else if ((content || '').startsWith(HTTP)) {
            // try and force https
            href.textContent = 'https://' + content.substring(HTTP.length);
        }
    });

    return Promise.all(promises).then(() => doc, () => doc);
}

export class KMZ implements AsyncFeatureFormat {
    public async readFeatures(source: ArrayBuffer | File | string, opt_options?: ReadOptions): Promise<Feature<Geometry>[]> {
        if (typeof source === 'string') return Promise.reject(new Error('Unsupported input type {string}'));
        const data = 'arrayBuffer' in source ? source : new Blob([source]);

        const jsz = new JSZip();

        const zip = await jsz.loadAsync(data);

        console.log(zip.files);

        const fmt = new KML({
            /*extractStyles: false*/
        });

        console.log('KMZ: read features from doc.kml');
        const doc = zip.file('doc.kml')
            || zip.filter(p => !!p.match(/\.kml$/))[0];

        if (!doc) return Promise.reject('no doc.kml');

        return doc.async('string')
            .then(content => fixKMZHrefs(content, zip))
            .then(xmlDoc => fmt.readFeatures(xmlDoc, opt_options));
    }
}